import { type DisplayDisableReason } from "@clientFrontend/features/scout/components/PremiumScoutMessageArea/type";

export const getReasonTexts = (displayDisableReason: DisplayDisableReason) => {
  if (displayDisableReason === "userInfoShortage") {
    return {
      boldText: "こちらの求職者は入力情報が足りず、\nAIでメッセージを作成できません。",
      text: "プロフィールの以下の項目を、50字以上記入済みの求職者に対して作成できます。\n自己PR／この業界を志した理由／大切にしていること／今後チャレンジしたいことのうち１つ",
    };
  }
  if (displayDisableReason === "normalPremiumScoutCountShortage") {
    return {
      boldText: "プレミアムスカウトの残数がないため、AIでメッセージを作成できません。",
      text: "",
    };
  }
  if (displayDisableReason === "nationalPremiumScoutCountShortage") {
    return {
      boldText: "国家のプレミアムスカウトの残数がないため、AIでメッセージを作成できません。",
      text: "",
    };
  }
  return {
    boldText: undefined,
    text: undefined,
  };
};
